/**
 * Resource điều chỉnh kinh phí chi
 * ntduong2 26/4/2023
 */
export default {
  Title: 'Điều chỉnh kinh phí chi',
  DetailTitle: 'Điều chỉnh kinh phí chi',
  BudgetSource: 'Nguồn',
  BankCode: 'Mã KBNN',
  BankCodeTitle: 'Mã kho bạc Nhà nước',
  Description: 'Diễn giải',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  AdjustDate: 'Ngày ĐC',
  AdjustDateTitle: 'Ngày điều chỉnh',
  AdjustNo: 'Số ĐC',
  AdjustNoTitle: 'Số điều chỉnh',
};
